module.exports = __webpack_public_path__ + "assets/img/hl_d_2.b4febbdd.png";